/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassInstanceDTO,
  ClassInstanceDTOOptional,
  ClassInstanceDTOMetaI,
  ClassInstanceDTOTrackedI,
} from "./class-instance-dto";
import {
  ClassInstanceDTOTracked,
  ClassInstanceDTOMeta,
} from "./class-instance-dto";

/**
 *
 * @export
 * @interface StaffClassesResponseDTO
 */
export interface StaffClassesResponseDTOOptional {
  /**
   *
   * @type {Array<ClassInstanceDTO>}
   * @memberof StaffClassesResponseDTO
   */
  classes?: ClassInstanceDTOOptional[];
}

export interface StaffClassesResponseDTO extends StaffClassesResponseDTOOptional {
  /**
   *
   * @type {Array<ClassInstanceDTO>}
   * @memberof StaffClassesResponseDTO
   */
  classes: ClassInstanceDTO[];
}

export interface StaffClassesResponseDTOTrackedI {
  /**
   *
   * @type {Array<ClassInstanceDTO>}
   * @memberof StaffClassesResponseDTO
   */
  classes?: ClassInstanceDTOTrackedI[];
  classesIsSet: boolean;
}

transformDatesMap.set(
  "StaffClassesResponseDTO",
  function (model: StaffClassesResponseDTO) {
    const transformDatesclasses = transformDatesMap.get("ClassInstanceDTO");
    if (transformDatesclasses) {
      model.classes?.forEach((sub) => {
        transformDatesclasses(sub);
      });
    }
  },
);

export type StaffClassesResponseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  classes: PropertyMeta<ClassInstanceDTOMetaI>;
}>;

export var StaffClassesResponseDTOMeta: StaffClassesResponseDTOMetaI =
  {} as StaffClassesResponseDTOMetaI;
StaffClassesResponseDTOMeta = typeMeta("StaffClassesResponseDTO", {
  classes: propertyMeta("classes", true, true, false, ClassInstanceDTOMeta),
});

const metaI = StaffClassesResponseDTOMeta;

registerMeta(() => {});

export class StaffClassesResponseDTOTracked implements StaffClassesResponseDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  classes__I?: ClassInstanceDTOTracked[] = undefined;
  classesIsSet: boolean = false;
  set classes(v: undefined | ClassInstanceDTOTracked[]) {
    if (v !== undefined) {
      this.classes__I = v;
      this.classesIsSet = true;
    } else {
      this.classes__I = v || undefined;
      this.classesIsSet = true;
    }
    this.changeTracker = true;
  }
  get classes() {
    return this.classes__I;
  }
  constructor(
    config?: StaffClassesResponseDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.classes?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: StaffClassesResponseDTOOptional,
    options?: AssignOptions,
  ): StaffClassesResponseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.classes && this.classesApplyFilter(optionsRequired.filter)) {
      this.classes = config.classes?.map(
        (a) => new ClassInstanceDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.classesIsSet = false;
      else this.classesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): StaffClassesResponseDTOTrackedI {
    const cloned = {} as StaffClassesResponseDTOTrackedI;
    if (
      this.classesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.classesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classesIsSet = true;
      cloned.classes = this.classes
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.classesIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): StaffClassesResponseDTOTrackedI {
    if (!this.classesApplyFilter(filter)) this.classesIsSet = false;

    this.classes?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  classesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffClassesResponseDTOMeta.classes,
      StaffClassesResponseDTOMeta,
      this.classes,
      this,
    );
  }
  classesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classesIsSet && this.classesApplyFilter(filter)) return true;

    return this.classes?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.classesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
